// extracted by mini-css-extract-plugin
module.exports = {"supportBar":"style_supportBar__11-Wo","home":"style_home__RCp1J"};